import PrivacyPolicy from "@_pages/PrivacyPolicy/PrivacyPolicy";
import LoginPage from "@_pages/Login/Login";
import SignupPage from "@_pages/Signup/Signup";
import AccountCreation from "@_pages/AccountCreation/AccountCreation";
import CasesPage from "@_pages/Cases/Cases";
import PaymentReports from "@_pages/PaymentReports/PaymentReports";
import PageNotFound from "@_pages/PageNotFound/PageNotFound";
import InvoiceManagement from "@_components/InvoiceManagement/InvoiceManagement";
import InboundEmails from "@_pages/InboundEmails/InboundEmails";
import EmailSetup from "@_pages/EmailSetup/EmailSetup";
import Credits from "@_pages/Credits/Credits";
import PaymentSetup from "@_pages/PaymentSetup/PaymentSetup";
import Subscription from "@_pages/Subscription/Subscription";
import Account from "@_pages/Account/Account";
import Dashboard from "@_components/Dashboard/Dashboard";
import BaseSettings from "@_pages/BaseSettings/BaseSettings";
import Languages from "@_pages/Languages/Languages";
import UserManagement from "@_pages/UserManagement/UserManagement";
import EmailFlows from "@_pages/EmailFlows/EmailFlows";
import InvoiceTemplates from "@_components/InvoiceTemplates/InvoiceTemplates";
import CaseTemplates from "@_components/CaseTemplates/CaseTemplates";
import SingleSignOnPage from "@_pages/SingleSignOn/SingleSignOn"

export const routeConstants = {
  PUBLIC_ROUTES: [
    {
      path: "/privacy-policy",
      component: PrivacyPolicy,
    },
    {
      path: ["/login", "/user/verification"],
      component: LoginPage,
    },
    {
      path: "/signup",
      component: SignupPage,
    },
    {
      path: "/account-creation",
      component: AccountCreation,
    },
    {
       path: "/sso",
       component: SingleSignOnPage,
    }
  ],

  PRIVATE_ROUTES: [
    {
      path: "/",
      component: Dashboard,
      exact: true,
    },
    {
      path: "/cases",
      component: CasesPage,
    },
    {
      path: "/accounting/payments",
      component: PaymentReports,
      exact: true,
    },
    {
      path: "/accounting/invoices",
      component: InvoiceManagement,
      exact: true,
    },
    {
      path: "/emails/unmapped",
      component: InboundEmails,
      exact: true,
    },
    {
      path: "/templates/email_flows",
      component: EmailFlows,
    },
    {
      path: "/templates/case_auto_fill",
      component: CaseTemplates,
    },
    {
      path: "/admin/account/email_setup",
      component: EmailSetup,
      exact: true,
    },
    {
      path: "/admin/account/credits",
      component: Credits,
      exact: true,
    },
    {
      path: "/admin/account/payment_setup",
      component: PaymentSetup,
      exact: true,
    },
    {
      path: "/admin/account/subscription",
      component: Subscription,
      exact: true,
    },
    {
      path: "/admin/account/business_details",
      component: Account,
      exact: true,
    },
    {
      path: "/admin/account/users",
      component: UserManagement,
    },
    {
      path: "/templates/invoices",
      component: InvoiceTemplates,
    },
    {
      path: "/admin/settlement_portal/base_settings/portal_address",
      component: BaseSettings,
      exact: true,
    },
    {
      path: "/admin/settlement_portal/base_settings/legal_and_contact",
      component: BaseSettings,
      exact: true,
    },
    {
      path: "/admin/settlement_portal/base_settings/logo_and_images",
      component: BaseSettings,
      exact: true,
    },
    {
      path: "/admin/settlement_portal/translations",
      component: Languages,
    },
    {
      path: "/page_not_found",
      component: PageNotFound,
      exact: true,
    },
    {
      path: "/dashboard",
      component: Dashboard,
      exact: true,
    },
  ],

  PUBLIC_PATHS: [
    "/login",
    "/user/verification",
    "/signup",
    "/account-creation",
    "/privacy-policy",
  ],
};
